/* eslint-disable @next/next/no-img-element */
import PropTypes from 'prop-types';
import React from 'react';
import { replaceImageServer, usePlaceholderImage } from '../../helpers/image';

const ImageComponent = ({ deal, height, priority, width }) => {
  const fallbackImage = deal?.images?.[0];
  const primaryImage = deal?.image || fallbackImage;

  return (
    <img
      alt={deal?.image?.alt || fallbackImage?.alt || 'Deal Image'}
      fetchpriority={priority ? 'high' : 'low'}
      height={height}
      loading={priority ? 'eager' : 'lazy'}
      onError={usePlaceholderImage}
      src={replaceImageServer({
        dealId: deal?.id,
        height,
        image: primaryImage,
        isSubSubCat: true,
        width,
      })}
      width={width}
    />
  );
};

ImageComponent.propTypes = {
  deal: PropTypes.object,
  height: PropTypes.number,
  priority: PropTypes.bool,
  width: PropTypes.number,
};

export default ImageComponent;
